import styled from 'styled-components'
import { Grid as GridFlex } from 'react-styled-flexboxgrid'

// Button with ripple animation
const Grid = styled(GridFlex)`
    max-width: 100%;
    box-sizing: content-box;
`

export default Grid
